import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { ApiEnvelope } from '../../../types';
import { drChronoTasksMock } from '../mockData';
import { DrChronoTask } from '../types';
import { DRCHRONO_TASKS_KEY } from './constants';

/** Reads rtm-api's local copy of the tasks, newest update first; `[]` when not linked. */
const useGetDrChronoTasks = (member_id: number | null | undefined) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        if (envVars.USE_EHR_MOCK_DATA) {
            return Promise.resolve(drChronoTasksMock);
        }

        return req<ApiEnvelope<DrChronoTask[]>>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/drchrono-tasks/`
        });
    }, [member_id, req]);

    return useQuery({
        queryKey: [DRCHRONO_TASKS_KEY, member_id],
        queryFn: request,
        select: (response) => response.data,
        enabled: !!member_id
    });
};

export default useGetDrChronoTasks;
